import { MunicipalityCollection } from './Municipality'
import { RegionCollection } from './Region'
import { SchoolCollection } from './School'
import { TimezoneCollection } from './Timezone'

export interface User {
  address: string | null;
  comment: string | null;
  created_at: string;
  deleted_at: string | null;
  email: string;
  full_name: string;
  id: number;
  is_active: boolean;
  is_superuser: boolean;
  last_login_at: string | null;
  last_login_ip: string | null;
  last_password_change_at: string | null;
  municipality: MunicipalityCollection | null;
  municipality_id: MunicipalityCollection['id'] | null;
  phone: string | null;
  photo: string | null;
  region: RegionCollection | null;
  region_id: RegionCollection['id'] | null;
  school: SchoolCollection | null;
  school_id: SchoolCollection['id'] | null;
  timezone: TimezoneCollection | null;
  timezone_id: TimezoneCollection['id'] | null;
  updated_at: string;
  username: string;
}

type CollectionKeys =
  | 'full_name'
  | 'id'
  | 'is_active'
  | 'is_superuser'
  | 'last_login_at'
  | 'username'

export type UserCollection = Pick<User, CollectionKeys>

type ProfileKeys =
  | 'id'
  | 'address'
  | 'email'
  | 'full_name'
  | 'municipality_id'
  | 'phone'
  | 'photo'
  | 'region_id'
  | 'school_id'
  | 'username'

export interface UserProfile extends Pick<User, ProfileKeys> {
  hash_sum: string;
  permissions: Record<string, Record<string, string[]>>;
  publications_curator?: number[];
  is_superuser?: boolean;
  is_federal_level?: boolean;
  is_admin?: boolean;
}

export interface UserContacts {
  email?: string | null;
  phone?: string | null;
  photo?: File | null;
}

export interface UserHistory {
  id: number;
  created_at: string;
  user_data: string;
  user: Pick<User, 'id'|'username'|'full_name'>;
}


export interface UserHistoryCollection {
  id: number;
  created_at: string;
  user: Pick<User, 'id'|'username'>;
}

export interface LkUser extends UserProfile {
  suas_user_id: string | number | null;
}

export interface LkUserCollection extends UserCollection {
}

export const enum UserActionTypes {
  login = 'login',
  edit = 'edit',
  create = 'create',
  delete = 'delete',
  download = 'download',
  upload = 'upload',
  suas_login = 'suas_login',
}

export const getUserActionTypeName = (type: UserActionTypes) => {
  switch (type) {
    case UserActionTypes.login:
      return {
        label: 'авторизация',
      }

    case UserActionTypes.edit:
      return {
        label: 'редактирование',
      }

    case UserActionTypes.download:
      return {
        label: 'скачивание файла',
      }

    case UserActionTypes.create:
      return {
        label: 'создание',
      }

    case UserActionTypes.delete:
      return {
        label: 'удаление',
      }

    case UserActionTypes.upload:
      return {
        label: 'загрузка файла',
      }

    case UserActionTypes.suas_login:
      return {
        label: 'suas авторизация',
      }

    default:
      return {
        label: type,
      }
  }
}

export interface UserActionCollection {
  action_type: UserActionTypes;
  created_at: string;
  description?: string;
  id: number;
  object_id: number | null;
  object_model_name: string | null;
  user_id: User['id'];
  suas_user_id: number | null;
  suas_user_username: number | null;
}

export interface UserParticipantsCollection {
  id: number;
  name: string;
  created_at: string;
  updated_at: string;
}
